export const contactInfo = {
  telegram: 'https://t.me/siteguarder',
  telegramHandle: '@siteguarder',
  email: 'mailto:contact@siteguarder.com',
  emailDisplay: 'contact@siteguarder.com'
};

export const siteContent = {
  meta: {
    home: {
      title: 'SiteGuarder - Enterprise Cybersecurity & Brand Protection Services',
      description: 'Professional anti-phishing, DMCA takedown, and digital brand protection services. Protect your business from cyber threats with 24/7 monitoring.',
      keywords: 'anti-phishing, DMCA takedown, brand protection, cybersecurity, threat detection, digital security'
    },
    services: {
      title: 'Our Services - Anti-Phishing, DMCA & Brand Protection | SiteGuarder',
      description: 'Comprehensive cybersecurity services including anti-phishing protection, DMCA notices, brand monitoring, and threat intelligence.',
      keywords: 'cybersecurity services, phishing protection, DMCA service, brand monitoring, threat intelligence'
    },
    about: {
      title: 'About SiteGuarder - Leading Cybersecurity Solutions Provider',
      description: "Learn about SiteGuarder's mission to protect businesses from cyber threats. Trusted by enterprises worldwide for digital security.",
      keywords: 'cybersecurity company, digital protection, security solutions, enterprise security'
    },
    contact: {
      title: 'Contact SiteGuarder - Get Professional Security Consultation',
      description: 'Get in touch with our security experts. Available 24/7 for immediate threat response and consultation.',
      keywords: 'security consultation, contact cybersecurity, threat response, security support'
    }
  },
  nav: {
    home: 'Home',
    services: 'Services',
    about: 'About',
    contact: 'Contact'
  },
  hero: {
    title: 'Protect Your Digital Assets',
    subtitle: 'Enterprise-Grade Cybersecurity Solutions',
    description: 'Advanced anti-phishing detection, DMCA enforcement, and comprehensive brand protection. Trusted by leading organizations worldwide.',
    cta: 'Get Protected',
    ctaSecondary: 'View Services'
  },
  services: {
    title: 'Our Services',
    subtitle: 'Comprehensive protection for your digital presence',
    items: [
      {
        name: 'Anti-Phishing Protection',
        description: 'Real-time detection and takedown of phishing sites targeting your brand. 24/7 monitoring with AI-powered threat intelligence.',
        icon: 'Shield',
        features: [
          'Real-time phishing detection',
          'Automated takedown requests',
          'Brand impersonation monitoring',
          'Threat intelligence reports',
          'Domain spoofing alerts',
          'Credential leak monitoring'
        ]
      },
      {
        name: 'DMCA Takedown Service',
        description: 'Fast and effective DMCA notices to protect your intellectual property. Professional handling of copyright infringement cases.',
        icon: 'FileText',
        features: [
          'Professional DMCA notices',
          'Copyright infringement tracking',
          'Content removal coordination',
          'Legal compliance support',
          'Counter-notice handling',
          'Global enforcement network'
        ]
      },
      {
        name: 'Digital Brand Protection',
        description: 'Comprehensive monitoring and protection of your brand across the internet. Prevent trademark abuse and counterfeiting.',
        icon: 'Lock',
        features: [
          'Brand monitoring across platforms',
          'Trademark infringement detection',
          'Counterfeit product tracking',
          'Domain squatting prevention',
          'Social media impersonation alerts',
          'Dark web brand monitoring'
        ]
      }
    ]
  },
  stats: [
    { number: '10K+', label: 'Threats Detected' },
    { number: '500+', label: 'Clients Protected' },
    { number: '24/7', label: 'Monitoring' },
    { number: '99.9%', label: 'Uptime' }
  ],
  about: {
    title: 'About SiteGuarder',
    subtitle: 'Leading the future of digital security',
    mission: 'Our mission is to provide enterprise-grade cybersecurity solutions that protect businesses from evolving digital threats. We combine advanced technology with expert analysis to deliver comprehensive protection for your brand, intellectual property, and online presence.',
    values: [
      {
        title: 'Security First',
        description: 'We prioritize security in everything we do, ensuring your digital assets are protected around the clock.',
        icon: 'Shield'
      },
      {
        title: 'Fast Response',
        description: 'Immediate action on detected threats with average response times under 15 minutes.',
        icon: 'Zap'
      },
      {
        title: 'Expert Team',
        description: 'Certified security professionals with decades of combined experience in cybersecurity.',
        icon: 'Users'
      },
      {
        title: 'Transparency',
        description: 'Clear reporting and communication with detailed insights into your security posture.',
        icon: 'Eye'
      }
    ]
  },
  contact: {
    title: 'Get In Touch',
    subtitle: 'Our security experts are ready to help',
    telegram: 'Telegram',
    email: 'Email',
    description: 'Contact us for immediate threat response or to discuss your security needs. Our team is available 24/7.'
  },
  footer: {
    company: 'SiteGuarder',
    tagline: 'Enterprise Cybersecurity Solutions',
    rights: 'All rights reserved',
    quickLinks: 'Quick Links',
    services: 'Our Services'
  }
};